export default __webpack_public_path__ + "static/media/cat@3x.7e4adccc.png";